import { BsFillCircleFill } from 'react-icons/bs';
import cover from "../imgs/cover.jpg";
import pp from "../imgs/pp.jpg";

export default function Header(){
    return(
        <div className="position-relative">
            <div className="coverContainer overflow-hidden">
                <img src={cover} alt="Cover" />
            </div>

            <div className="profilePicContainer position-absolute bottom-0 ms-4 rounded-circle">
                <div className="position-relative rounded-circle p-2">

                    <div className="overflow-hidden position-relative rounded-circle">
                        <img src={pp} alt="Profile" />
                    </div>

                    <div className="position-absolute bottom-0 end-0 mb-2 me-1">
                        <BsFillCircleFill size={35} className="activeIcon rounded-circle" />
                    </div>

                </div>
            </div>
        </div>
    )
}